import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type UiState = {
  sidebarOpen: boolean;
};

const initialState: UiState = {
  sidebarOpen: true,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen(state, action: PayloadAction<boolean>) {
      state.sidebarOpen = action.payload;
    },
  },
});

export const { setSidebarOpen, toggleSidebar } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
